import { AxiosResponse } from "axios";
import { useState } from "react";

import { useProductService } from "@/api/hooks/productService.hook";
import {
    SafetyInfoDocument,
    SafetyInfoDocumentModel,
    SafetyInfoResponse
} from "@/api/mappers/safetyInfoDocument.mapper";
import { Messages } from "@/components/General/Messages/messages.container";
import {
    broadcastMessage,
    clearMessageById
} from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { SafetyInfo } from "./safetyInfo.component";

const SafetyInfoContainer = () => {
    const { t } = useGranite();

    const [documents, setDocuments] = useState<Array<SafetyInfoDocumentModel>>(
        []
    );
    const [loading, setLoading] = useState(false);

    const productService = useProductService();

    const showErrorMessage = () => {
        broadcastMessage({
            id: "product-safety-info-failure",
            text: t("productSafetyInfo.component.failure"),
            status: "danger",
            dismissible: false,
            activeScroll: true
        });
    };

    const handleDocumentsResponse = (
        mappedDocuments: Array<SafetyInfoDocumentModel>
    ) => {
        setDocuments(mappedDocuments);

        if (mappedDocuments.length > 0) {
            clearMessageById("product-safety-info-failure");
        } else {
            showErrorMessage();
        }
    };

    const handleOnSubmit = (search: number) => {
        if (!search) return;

        setLoading(true);

        productService
            .get<
                unknown,
                AxiosResponse<SafetyInfoResponse>,
                Array<SafetyInfoDocumentModel>
            >(`/safetydocuments`, { params: { search } })
            .then(({ data }) => data)
            .then(SafetyInfoDocument)
            .then(handleDocumentsResponse)
            .catch(() => {
                setDocuments([]);
                showErrorMessage();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Messages messageid="product-safety-info-failure" />
            <SafetyInfo
                isLoading={loading}
                safetyDocuments={documents}
                onSubmit={handleOnSubmit}
            />
        </>
    );
};

export { SafetyInfoContainer };
